export class AnalyticsConstants {
  static CATEGORY_CONTACT = 'Contact';
  static CATEGORY_FEATURE = 'Feature';
  static EVENT_WHATSAPP = 'Whatsapp';
  static EVENT_EMAIL = 'Email';
  static MAKE_CALL = 'Make call';
  static MAKE_VIDEOCALL = 'Make videocall';
  static DOWNLOAD_CSV = 'Download csv';
  static CHAT_CARNOVO = 'Chat Carnovo';
  static CARWOW = 'Carwow';
  static PSA = 'PSA';
  static NIW = 'Niw';
  static UNREAD_NOTICES = 'Unread notices';
  static READ_NOTICES = 'Read notices';
  static READ_NOTICES_URL = 'Read notices info url';
  static HEYCAR = 'Heycar';
  static DAPDA_360 = 'Dapda 360';
  static AUTONET_360 = 'Autonet 360';
  static STOCK_360 = 'Stock 360';
  static BDCNET_360 = 'Bdcnet 360';
}
